import React from 'react'

function ProgramHeadSlider() {
    return <>
        <h1 className="h1 title text-center">Apply today and be</h1>
        <h1 className='h1 title text-center'>a <span className='red game'>game</span> chenger </h1>
    </>

}

export default ProgramHeadSlider